import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import PaginateList from "../../../utils/PaginateList";
import * as TaskServices from "../../../../services/TaskService";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../constants/paths";
import {
  ButtonAction,
  ButtonClose,
  Icon,
  Option,
  ListOptions,
} from "./taskList.styled";
import { Can, AbilityContext } from "../../../security/permissions/Can";
import {} from "../../../security/permissions/rolesPermission";
import {
  checkBootstrapSizeBreak,
  SIZES,
} from "../../../../utils/device/checkDevice";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";

const TaskListContainer = ({ filters, sortBy }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const deviceSize = checkBootstrapSizeBreak();
  const [forceRefresh, setForceRefresh] = useState(false);
  const context = useContext(AbilityContext);

  const columns = [
    {
      header: t("forms.task.table.heads.code"),
      accessorKey: "code",
      cell: (info) => info.getValue(),
      size: 80,
    },
    {
      header: t("forms.task.table.heads.name"),
      accessorKey: "name",
      cell: (info) => {
        if (i18n.language === "pt") {
          return info.row.original.namePt;
        }

        return info.getValue();
      },
      size: 200,
    },
    {
      header: t("forms.task.table.heads.performance"),
      accessorKey: "performance",
      cell: (info) => info.getValue(),
      size: 40,
    },
    {
      header: t("forms.task.table.heads.culture"),
      accessorKey: "culture",
      cell: (info) => t(info.getValue()),
      size: 50,
    },
    {
      header: t("forms.task.table.heads.active"),
      accessorKey: "active",
      cell: (info) => {
        if (info.getValue()) {
          return t("yes");
        }

        return t("no");
      },
      size: 40,
    },
    {
      Header: " ",
      accessorKey: " ",
      cell: (info) => renderAction(info.row.original),
      size: 60,
    },
  ];

  const goToEdit = (uuid) => {
    navigate(`/user/task/form/update/${uuid}`);
  };

  const renderAction = (data) => {
    return (
      <div className="text-center">
        <ButtonAction onClick={() => goToEdit(data.uuid)} type="button">
          <i className="fa-regular fa-pen-to-square"></i>
        </ButtonAction>
        <ButtonAction
          onClick={() => showDialogOnDelete(data.uuid)}
          type="button"
        >
          <Icon className="fa-solid fa-trash-can"></Icon>
        </ButtonAction>
      </div>
    );
  };

  const showDialogOnDelete = (uuid) => {
    const okAction = async () => {
      TaskServices.deleteTask(uuid).then((result) => {
        if (result && result.deleted === true) {
          setForceRefresh(true);
        }
      });
    };

    const cancelAction = () => {};

    ShowAlertDialog(
      t("forms.task.dialog.remove.title"),
      t("forms.task.dialog.remove.text"),
      "warning",
      true,
      t("forms.task.dialog.remove.buttonOk"),
      false,
      okAction,
      t("forms.task.dialog.remove.buttonNo"),
      cancelAction
    );
  };

  const listData = async (filter) => {
    // if (sortBy) {
    //   filter.sort = sortBy;
    // } else {
    //   filter.sort = "-date";
    // }
    const result = await TaskServices.listFilter(filter);
    return result;
  };

  const hideColumn = {};
  let resize = null;

  if (deviceSize < SIZES.md) {
    // hideColumn.itemCode = false;
    resize = false;
  } else if (deviceSize === SIZES.md) {
    // hideColumn.itemCode = false;
  }

  return (
    <PaginateList
      refresh={forceRefresh}
      filters={filters}
      columns={columns}
      toList={listData}
      hideColum={hideColumn}
      resize={resize}
      resetRefresh={() => setForceRefresh(false)}
    ></PaginateList>
  );
};

TaskListContainer.propTypes = {
  filters: PropTypes.object,
};

export default TaskListContainer;
